module.exports = __webpack_public_path__ + "static/img/COC2023-30.c35058b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-30.png
// module id = FjDT
// module chunks = 0